import React from "react"
import EntryListCard from "./entry-list-card"

const EntryList = ({ postEdges }) => {
  return postEdges.map(({ node }) => {
    return <EntryListCard frontmatter={node.frontmatter} fields={node.fields} excerpt={node.excerpt} />
  })
}

export default EntryList